// The server repeats these validations; this helper is only the UI preview.
export function normalizarFaixas(value) {
  let rows = value;
  if (typeof rows === 'string') {
    try { rows = JSON.parse(rows); } catch (_) { throw new Error('As faixas salvas são inválidas.'); }
  }
  if (rows == null) return [];
  if (!Array.isArray(rows)) throw new Error('Informe uma lista de faixas.');
  const faixas = rows.map(row => ({
    min: Number(row.min),
    max: row.max == null || row.max === '' ? null : Number(row.max),
    desconto: row.desconto === '' || row.desconto == null ? NaN : Number(row.desconto),
  })).sort((a, b) => a.min - b.min);
  faixas.forEach((row, index) => {
    if (!Number.isSafeInteger(row.min) || row.min < 1
      || (row.max !== null && (!Number.isSafeInteger(row.max) || row.max < row.min))) {
      throw new Error(`Faixa ${index + 1}: informe quantidades inteiras válidas, a partir de 1.`);
    }
    if (!Number.isFinite(row.desconto) || row.desconto < 0 || row.desconto > 99.99) {
      throw new Error(`Faixa ${index + 1}: o desconto deve ser de 0 a 99,99%.`);
    }
    if ((index === 0 && row.min !== 1)
      || (index > 0 && (faixas[index - 1].max === null || row.min !== faixas[index - 1].max + 1))) {
      throw new Error('Comece em 1 e mantenha as faixas em sequência, sem lacunas nem quantidades repetidas.');
    }
  });
  return faixas;
}

export function precoPorFaixa(base, value, quantidade) {
  const faixas = normalizarFaixas(value);
  const precoBase = Number(base);
  if (!Number.isFinite(precoBase) || precoBase <= 0) throw new Error('Informe um preço-base maior que zero.');
  if (!Number.isSafeInteger(Number(quantidade)) || Number(quantidade) < 1) {
    throw new Error('Informe uma quantidade inteira maior que zero.');
  }
  const faixa = faixas.find(row => Number(quantidade) >= row.min
    && (row.max === null || Number(quantidade) <= row.max));
  if (faixas.length && !faixa) throw new Error('A quantidade não está coberta pelas faixas desta promoção.');
  const desconto = faixa ? faixa.desconto : 0;
  const preco = Number((precoBase * (1 - desconto / 100)).toFixed(4));
  if (preco <= 0) throw new Error('O desconto não pode resultar em preço zero.');
  return { preco, desconto, faixa: faixa || null };
}